import RootComponent from '../../features/root/root.component';

const Root = () => <RootComponent />;

export default Root;
